import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);
    return null;
};

export const Section = ({ children, className = "", tone = "white" }) => (
    <section
        className={`${tone === "soft" ? "bg-[#F3F7F9]" : tone === "dark" ? "bg-[#03283D] text-white" : "bg-white"} ${className}`}
    >
        <div className="container-ys section">{children}</div>
    </section>
);

export const SectionHeader = ({ eyebrow, title, subtitle, align = "left" }) => (
    <div className={`mb-8 ${align === "center" ? "text-center mx-auto max-w-2xl" : ""}`}>
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h2 className="mt-3 text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h2>
        {subtitle && (
            <p className="mt-3 text-base md:text-lg text-[#17252D]/75 max-w-3xl">{subtitle}</p>
        )}
    </div>
);

export const Placeholder = ({ children }) => (
    <span className="placeholder-chip text-xs">{children}</span>
);
